import '../../../app.es6';
import angular from 'angular';

const COMPONENT_NAME = 'dialogSignOut';
class DialogSignOut {
  /* @ngInject */
  constructor ($location, $sessionStorage, Resource, SharedState, commonFactory, Const) {
    this.Const = Const;
    this.Resource = Resource;
    this.$location = $location;
    this.$sessionStorage = $sessionStorage;
    this.UiSharedState = SharedState;
    this.commonFactory = commonFactory;
    DialogSignOut.$inject = [
      '$location', '$sessionStorage', 'Resource', 'SharedState', 'commonFactory', 'Const'
    ];
  }

  signOut () {
    this.UiSharedState.turnOff('dialogSignOutPopup');
    if (localStorage.getItem(this.Const.LSAPP_ROLE) === this.Const.LSAPP_ROLE_MEMBER) {
      this.$location.path('/member/login');
    } else {
      this.$location.path('/staff/login');
    }
    this.commonFactory.deleteLocalStorage();
    this.commonFactory.deleteSessionStorage();
    this.commonFactory.deleteErrorFlg();
  }
}

angular.module('myApp').component(COMPONENT_NAME,
  {
    bindings: {
      name: '@' + COMPONENT_NAME
    },
    controller: DialogSignOut,
    templateUrl: 'app/components/dialog/sign-out/dialog-sign-out.template.html'
  }
);



// WEBPACK FOOTER //
// ./app/components/dialog/sign-out/dialog-sign-out-controller.es6